export default __webpack_public_path__ + "static/people_03-5226a8900ba4d0dd948f3d9285df078a.png";